import CityPageTemplate from "../city-template/CityPageTemplate";
import { rockvilleConfig } from "./data";

export default function RockvillePage() {
  return <CityPageTemplate config={rockvilleConfig} />;
}